module.exports = __webpack_public_path__ + "static/img/12.70764b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/eng/12.png
// module id = aLMw
// module chunks = 0